import React from 'react';
import { StyledLeadContainer,  StyledCompanyContainer, StyledConfigurationContainer, StyledIndexContainerDiv } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import { Box, Stack, Button, Typography, Tooltip } from '@mui/material';
import { GridRowModes,GridActionsCellItem } from '@mui/x-data-grid';import { useState } from 'react';
import SearchModuleButton from '../../../Components/SearchModuleButton';
import DataGridTable from '../../../Components/DataGrid';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BiztantuLoader from '../../../Components/Loader';
import {  dateFormatting , isValidEmail, isValidPhoneNumber, searchRequestData } from '../../../Utility/apiHelper';
import { useSnackbar } from 'notistack';
import CreateEditOrg from './CreateEditOrg';
import EditIcon from '@mui/icons-material/Edit';
import { ACTIVE_STATUS, constitutionOfBusinessWidth, emailWidth, fullNameWidth, handleValidateCodevalue, idWidth, nameWidth, phoneWidth, statusWidth, whocolumnWidth } from '../../../Utility/constant';
import { WhoColumns } from '../../../Components/WhoColumns';
import CommonPoc from '../../../Components/CommonPoc';
import BiztantuSearch from '../../../Components/BiztantuSearch';
import { handleCreateEditConfiguration } from '../../../Store/Global/action';
import { requestGetAllClients } from '../../../Store/Client/action';
import tableBodyicon from '../../../Assets/images/tablebody_edit.png'
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import createicon from '../../../Assets/images/add.png';
import axios from 'axios';
import { sessionExpiredDialog } from '../../../Utility/sessionExpired';

const Organizaion = ({}) => {
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [isLoading,setIsLoading] = useState(false);
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 180);
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState({
    updatedFrom: dateFormatting(sevenDaysAgo),
    updatedTo: dateFormatting(today),
    });
    const [datagriddata, setdatagriddata] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [iscreateuser, setCreateuser] = useState(false);
    const [isEdituser, setEdituser] = useState(false);
    const [currentuserid, setcurrentuserid] = useState("");
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const clientData = useSelector(state => state?.client?.client);
    const [assignRoleDetails, setassignroledetails] = useState({
      isOpen: false
    });
    const clientCOBData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_BUSINESS_CONSTITUTION')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const clientStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'CLIENT_STATUS')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);

    useEffect(() => {
        handleSearch()
      return()=>{
        setdatagriddata([])
      }
    }
,[])

    useEffect(()=>{
      const updatedClientTable = (clientData || []).map(item => {
                  return {
                    ...item,
                    id: item?.id
                  }
                })
    setdatagriddata(updatedClientTable)
    },[clientData])

    const {enqueueSnackbar} = useSnackbar();

    const allrolesData = useSelector(state => state?.permission?.allRoleTypes);

    const handleOnChange = (event) => {
        setFormValues({
            ...formValues,
            [event.target.name]: event.target.value
        })
    }

    const handleSaveClick = (id) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    }

    const handleEditClick = (id) => {
          setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    }


    const handleEditApplication = (id,value) => {
        setEdituser(true);
        setCreateuser(false);
        setcurrentuserid(id);
        dispatch(handleCreateEditConfiguration(true));
    }

  const handleCancelClick = (id) => {
    setRowModesModel({
    ...rowModesModel,
    [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  }

    const columns = [
      
        {
          field: 'actions',
          type: 'actions',
          headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
    
            if (isInEditMode) {
              return [
                <GridActionsCellItem
                  icon={<CheckIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                  className="textPrimary"
                  onClick={()=>{handleSaveClick(id)}}
                />,
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                  className="textPrimary"
                  onClick={()=>{handleCancelClick(id)}}
                  color="inherit"
                />,
              ];
            }
    
            return [
              <GridActionsCellItem
                icon={<img src={tableBodyicon} />}
                label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                className="textPrimary"
                onClick={()=>{handleEditClick(id)}}
                color="inherit"
              />,
              // <GridActionsCellItem
              //   icon={<BorderColorIcon />}
              //   label={handleValidateCodevalue(internationalise,'CONFIGURATION_CLIENT_EDIT_RECORD')}
              //   className="textPrimary"
              //   onClick={() => handleEditApplication(id,false)}
              //   color="inherit"
              // />,
            ];
          },
        },
      { 
        field: 'id', 
        headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_ID'),
        flex: 1,
        minWidth : idWidth,
        editable: false ,
        renderCell : ({id})=>(
          <span
          onClick={() => handleEditApplication(id,true)}
          style={{
            color: '#1242C8',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          >
            {id}
          </span>
        )
        
      },
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_LN'),
          flex: 1,
          minWidth : fullNameWidth,
          editable: true ,
        },
        { 
          field: 'tradeName', 
          headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_TN'),
          flex: 1,
          minWidth : fullNameWidth,
          editable: true ,
        },
        {
          field: 'pocFirstName',
          headerName: handleValidateCodevalue(internationalise,'COMMON_POC_FIRSTNAME'),
          flex: 1,
          minWidth : nameWidth,
          editable: true,
      },
        {
          field: 'pocLastName',
          headerName: handleValidateCodevalue(internationalise,'COMMON_POC_LASTNAME'),
          flex: 1,
          minWidth : nameWidth,
          editable: true,
      },
        {
            field: 'pocEmail',
            headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
            flex: 1,
            minWidth : emailWidth,
            editable: true,
        },
      { 
        field: 'clientCode', 
        headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_CODE'),
        flex: 1,
        minWidth : nameWidth,
        editable: false ,
      },
        {
          field: 'pocPhone',
          headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
          flex: 1,
          minWidth : phoneWidth,
          editable: false,
        },
        {
          field: 'status',
          headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_STATUS'),
          flex: 1,
          minWidth : statusWidth,
          editable: false,
          valueGetter:({value})=>{
            if(!value){
              return ""
            }
              return handleValidateCodevalue(internationalise,value)
            }
        },
        {
          field: 'constitutionOfBusiness',
          headerName: handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_COB'),
          flex: 1,
          minWidth : constitutionOfBusinessWidth,
          editable: false,
          valueGetter:({value})=>{
            if(!value){
              return ""
            }
              return handleValidateCodevalue(internationalise,value)
            }
          },
        {
          field: 'createdAt',
          headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
          type: 'date',
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
        {
          field: 'updatedAt',
          type: 'date',
          headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
      ];

    const handleSearch = async() => {
            setIsLoading(true);
            const queryparams = {
              params: {
                ...formValues,
                tradename: formValues?.tradeName,
                pocMobileNumber : formValues?.pocPhone,
                firstName : formValues?.pocFirstName,
                lastName : formValues?.pocLastname
              },
            };
            dispatch(requestGetAllClients(queryparams))
            setIsLoading(false);
              }

    const handleResetSearch = () => {
      setFormValues({
        id:"",
        clientCode:"",
        name:"",
        tradeName:"",
        status : "",
        constitutionOfBusiness:"",
        pocName:"",
        pocPhone:"",
        pocEmail:"",
        createdFrom:"",
        createdTo:"",
        updatedFrom:"",
        updatedTo:""
        
      })
      
    }

    const handleCreateuser = () => {
        setCreateuser(true);
        dispatch(handleCreateEditConfiguration(true));
    }
    
    const handlebackbutton = () => {
        setEdituser(false);
        setCreateuser(false);
        dispatch(handleCreateEditConfiguration(false));
        handleSearch(formValues);
    }

    const handleAssignRoles = () => {
      setassignroledetails({
        ...assignRoleDetails,
        isOpen: true
      })
    }

    const handleInEditOrg = (currentClientId) => {
      setEdituser(true);
      setcurrentuserid(currentClientId);
        
    }
    
  
    const handleUpdateClient = (rowRecord) => {
      if(!isValidEmail(rowRecord?.pocEmail)){
          enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
          return;
      }
      if(!isValidPhoneNumber(rowRecord?.pocPhone)){
          enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_PHONE"),{variant:'error'});
          return;
      }
      setIsLoading(true)
      
        const formData = new FormData();
      const headerReq = {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
              }
          }
      
          const Id = rowRecord?.id;
      
          const { ['id']: id, ['updated']: updated, ...UpdatedUserData} = rowRecord;
          
          const payload = {
              ...UpdatedUserData,
          }
            formData.append("client", JSON.stringify(payload));
          axios.put(`${process.env.REACT_APP_BASE_URL}companies/${Id}`, formData, headerReq).then(response => {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'})
              
          }).catch(error => {
            if(error?.response?.status == 401) {
              sessionExpiredDialog();
            } else {
              enqueueSnackbar(handleValidateCodevalue(internationalise,error || "COMMON_PLEASE_TRY_AGAIN"),{variant:"error"})
            }
          }).finally(() => {
            setIsLoading(false);
          });
        }
    
        const processRowUpdate = (newRow, oldRow) => {
                if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
                  enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
                } else {
                  handleUpdateClient(newRow); 
                }
            const updatedRow = { ...newRow, isNew: false };
            setdatagriddata(datagriddata.map((row) => (row.id === newRow.id ? updatedRow : row)));
            return updatedRow;
          ;
        }



    return (

        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
           {(!iscreateuser && !isEdituser) ? <Box sx={{marginBottom: 0,
                // '& .MuiTextField-root': { m: 1, width: '29ch', marginTop: 3 },
                }}>
            
                {/* <StyledFlexEnd>
                    <Button variant="outlined"  onClick={handleCreateuser}>Create User</Button>
                </StyledFlexEnd> */}
                <StyledConfigurationContainer>
                  <Typography variant='h6'>
                    {handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_TITLE')}
                  </Typography>
                </StyledConfigurationContainer>
                <StyledLeadContainer>
              {/* <StyledCompanyContainer>
                <TextFiledWithLabel
                required={false}
                type = "number"
                name= "id"
                value = {formValues?.id}
                label = {handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_ID')}
                handleOnChange={handleOnChange}
                />
              </StyledCompanyContainer> */}
                {/* <Stack spacing={2} direction="row">
                <Button variant="outlined"  onClick={handleCreateuser}>{ handleValidateCodevalue(internationalise,'COMMON_CREATE')}</Button>
                  </Stack> */}
              </StyledLeadContainer>
              <StyledIndexContainerDiv>
              <StyledLeadContainer sx={{backgroundColor: "#F4F9FE"}}>
                <Stack className='table-header-search' spacing={2} width="40%" direction="row" backgroundColor="white">
                        <BiztantuSearch
                        handleReset={handleResetSearch}
                        handleSearch = {handleSearch}
                        entityDetails={formValues}
                        
                        >
                <Box sx={{
                  '& .MuiTextField-root': { m: 1, width: '25ch', marginTop: 2 },
                }}>
                <StyledCompanyContainer>
                  <TextFiledWithLabel
                required={false}
                type = "number"
                name= "id"
                value = {formValues?.id}
                label = {handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_ID')}
                handleOnChange={handleOnChange}
                />
                    <TextFiledWithLabel
                        name= "clientCode"
                        value= {formValues?.clientCode}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_CODE')}
                        handleOnChange={handleOnChange}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name= "status"
                        value= {formValues?.status || ""}
                        isStatic = {false}
                        optionMenuItem={clientStatusData}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_STATUS')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}/>
                    </StyledCompanyContainer>
                    <StyledCompanyContainer>
                    <TextFiledWithLabel
                        name= "name"
                        value= {formValues?.name}
                        label= {handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_LN')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                        name= "tradeName"
                        value= {formValues?.tradeName}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_TN')}
                        handleOnChange={handleOnChange}
                    />
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name= "constitutionOfBusiness"
                        value= {formValues?.constitutionOfBusiness || ""}
                        isStatic = {false}
                        optionMenuItem={clientCOBData}
                        label={handleValidateCodevalue(internationalise,'CONF_CLIENT_SEARCH_COB')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                    sx = {{visibility : "hidden"}}/>
                    </StyledCompanyContainer>
                    <CommonPoc
                    isDetailPage={false}
                    handleOnChange={handleOnChange}
                    state={formValues}
                    />
                <WhoColumns
                handleOnChange={handleOnChange}
                searchState={formValues}
                />
                </Box>
                </BiztantuSearch>
                    </Stack>
                     <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                        <>
                        <Button startIcon={<img src={createicon} style={{height: "15px"}} />} className='biztantu-sec-btn'  onClick={handleCreateuser}>{handleValidateCodevalue(internationalise,'CONF_CLIENT_CREATE')}</Button>
                        </>
                    </Stack>
                </StyledLeadContainer>
                <DataGridTable
                    dataGridData={datagriddata}
                    isLoading={isLoading}
                    columns={columns}
                    rowModesModel={rowModesModel}
                    height={"calc(100vh - 273px)"}
                    isRequiredToolBar = {true}
                    // gridType='accountuser'
                    selectionModel={selectionModel}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    handleAssignRoles = {handleAssignRoles}
                    handleProcessRowUpdate={processRowUpdate}
                    handleUpdateProduct={handleUpdateClient}
                    // handleUpdateProduct={handleUpdateProduct}
                />
                </StyledIndexContainerDiv>
           
            </Box> : 
                <CreateEditOrg
                    setdataGridData = {setdatagriddata}
                    isEdituser = {isEdituser} 
                    currentcompanyid={currentuserid}
                    handleCustomBackbutton = {handlebackbutton}
                    allrolesData = {allrolesData}
                    iscreateuser = {iscreateuser}
                    handleInEditOrg = {handleInEditOrg}
                />  
            }

        </BiztantuLoader>
    )
}

export default Organizaion;